import React from "react";
import { Car, Clock, Compass, MapPin, Repeat, Route } from "lucide-react";

function Feature({ icon, title, text }) {
  return (
    <div className="flex flex-col items-center text-center p-4 border rounded-2xl shadow-sm bg-gray-50">
      <div className="text-blue-600 mb-2">{icon}</div>
      <h4 className="font-semibold text-lg mb-1">{title}</h4>
      <p className="text-sm text-gray-600">{text}</p>
    </div>
  );
}

const KeyFeatures = () => {
  return (
    <>
      {/* Key Features */}
      <section className="max-w-5xl mx-auto text-center space-y-10 pt-12 pb-12 px-4 text-gray-800">
        <h2 className="text-3xl font-semibold">Key Features</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          <Feature
            icon={<MapPin />}
            title="What's nearby?"
            text="Discover what’s worth visiting around you, based on your interests"
          />
          <Feature
            icon={<Car />}
            title="No car? No problem!"
            text="Walking or public transport-friendly routes in any city"
          />
          <Feature
            icon={<Clock />}
            title="Time-based planning"
            text="Got 2 hours or a full day? WayPick adapts to your schedule"
          />
          <Feature
            icon={<Repeat />}
            title="Looped routes"
            text="Start and end at your hotel, city center, or any chosen point"
          />
          <Feature
            icon={<Compass />}
            title="Multi-day trip builder"
            text="Day-by-day itineraries created with one click"
          />
          <Feature
            icon={<Route />}
            title="Scenic detours"
            text="Automatically add hidden gems to your intercity drives"
          />
        </div>
      </section>
    </>
  );
}

export default KeyFeatures;